import MyContext from "../../../../contexts/MyContext";
import { TicketForm5New } from "../ticket-forms/TicketForm5New";

export const Slide5New = (props) => {
  return <MyContext.Consumer>{(context) => <div hidden={context.activeSlide !== 4}>{<TicketForm5New {...props} />}</div>}</MyContext.Consumer>;
};
